(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/game-card.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/game-card.js');

'use strict';

const {
  useContext,
  useLayoutEffect,
  useCallback,
  useRef
} = React;
const {
  useSelector
} = ReactRedux;
const {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const {
  Card,
  CardBody,
  CardHeader,
  CardFooter
} = svs.ui.ReactCard;
const Brand = svs.ui.ReactBrand;
const {
  RibbonCorner
} = svs.ui.ReactRibbon;
const {
  productMapping
} = svs.numbergames;
const animations = svs.numbergames.fractiongames.components.gamecard.animations;
const {
  ContainerContext
} = svs.numbergames.fractiongames.contexts;
const {
  CONTAINER_OPEN,
  GAME_SOLD_OUT,
  CONTAINER_CLOSED
} = svs.numbergames.fractiongames.constants.containerStates;
const {
  GameInfo,
  ExtraGameInfo,
  Header,
  Footer,
  FooterClosed
} = svs.numbergames.fractiongames.components.gamecard;
const GameCard = _ref => {
  let {
    onPayEvent
  } = _ref;
  const {
    selectors,
    hasActiveCampaign
  } = useContext(ContainerContext);
  const containerId = useSelector(selectors.selectContainerId);
  const activatedDrawId = useSelector(selectors.selectActivatedDrawId);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const sharePrice = useSelector(selectors.selectSharePrice);
  const containerState = useSelector(selectors.selectContainerState);
  const {
    jokerPrice,
    isSystemBoard
  } = useSelector(selectors.selectGame);
  const branding = productMapping.getBrandingClass(productNumeric);
  const productName = productMapping.getProductName(productNumeric);
  const activatedDrawIdRef = useRef(activatedDrawId);
  const animationRef = useRef();
  const cardRef = useRef();
  const buttonRef = useRef();
  const closedFooterRef = useRef();
  const closedRef = useRef();
  useLayoutEffect(() => {
    if (activatedDrawIdRef.current !== activatedDrawId) {
      if (activatedDrawIdRef.current && activatedDrawId) {
        animations.gameRegeneratedAnimation(cardRef.current);
      }
      activatedDrawIdRef.current = activatedDrawId;
    }
  }, [activatedDrawId]);
  useLayoutEffect(() => {
    let tl;
    switch (containerState) {
      case CONTAINER_CLOSED:
      case GAME_SOLD_OUT:
        tl = animations.toExpiredAnimation(buttonRef.current, closedFooterRef.current, closedRef.current, {
          paused: true
        });
        break;
      case CONTAINER_OPEN:
        tl = animations.toOpenAnimation(closedFooterRef.current, buttonRef.current, closedRef.current, {
          paused: true
        });
        break;
      default:
    }
    if (tl) {
      var _animationRef$current, _animationRef$current2, _animationRef$current4;
      if ((_animationRef$current = animationRef.current) !== null && _animationRef$current !== void 0 && (_animationRef$current2 = _animationRef$current.isActive) !== null && _animationRef$current2 !== void 0 && _animationRef$current2.call(_animationRef$current)) {
        var _animationRef$current3;
        (_animationRef$current3 = animationRef.current) === null || _animationRef$current3 === void 0 || _animationRef$current3.progress(1);
      }
      if (!animationRef.current) {
        tl.progress(1);
      }
      animationRef.current = tl;
      (_animationRef$current4 = animationRef.current) === null || _animationRef$current4 === void 0 || _animationRef$current4.play();
    }
  }, [containerState]);
  const handlePayClick = useCallback(e => {
    e.preventDefault();
    onPayEvent(containerId);
  }, [onPayEvent, containerId]);
  const handleToggleExtraInfo = useCallback((e, isExpanded) => {
    if (isExpanded) {
      svs.components.analytics.trackEvent({
        category: 'Andelsspel',
        action: 'Mer info',
        opt_label: productName,
        opt_value: parseInt(sharePrice, 10)
      });
    }
  }, [productName, sharePrice]);
  return React.createElement("div", {
    className: "ng-fg-card ng-fg-card-container-".concat(containerId),
    ref: cardRef
  }, React.createElement(Card, {
    align: "center",
    branding: "tur",
    className: "branding-".concat(branding)
  }, React.createElement("div", {
    ref: closedRef
  }, React.createElement(CardHeader, null, hasActiveCampaign && React.createElement(RibbonCorner, null, "Kampanj"), React.createElement("div", {
    className: "ng-fg-card-header-brand"
  }, React.createElement("h2", null, React.createElement(Brand, {
    brand: branding,
    emblem: true,
    size: 100
  }), Boolean(jokerPrice) && React.createElement("p", null, "med Joker"))), React.createElement(Header, null)), React.createElement(CardBody, null, React.createElement(GameInfo, null), React.createElement(Accordion, {
    isFlat: true
  }, React.createElement(AccordionItem, {
    onChange: handleToggleExtraInfo
  }, React.createElement(AccordionSummary, null, isSystemBoard ? 'System' : 'Enkelrader'), React.createElement(AccordionDetails, null, React.createElement(ExtraGameInfo, null)))))), React.createElement(CardFooter, null, React.createElement(Footer, {
    onPay: handlePayClick,
    ref: buttonRef
  }), React.createElement(FooterClosed, {
    ref: closedFooterRef
  }))));
};
svs.numbergames.fractiongames.components.gamecard.GameCard = GameCard;

 })(window);